module.exports = __webpack_public_path__ + "static/media/PayU.8612b9ea.png";